<template>
  <div class="main-content">
    <div class="container-fluid">
      <div class="row justify-content-center mx-3 mx-sm-0">
        <div :class="col">
          <slot></slot>
        </div>
      </div>
    </div>
</div>
</template>

<script>
export default {
  props: {
    col: {
      type: String,
      default: 'col-10'
    }
  }
}
</script>

<style></style>
